import {
	BriefcaseChecked,
	Calendar,
	Candidates,
	IForms,
	Location,
} from '@icims-design-system/icons';
import { Box, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const renderRecruiterInfo = (feedbackInfo, view, classes, recruiter) => {
	if (feedbackInfo.recruiterName && view === 'dashboardView') {
		return (
			<Box sx={classes.cardInfo}>
				<Candidates sx={classes.icon} />
				<Typography sx={classes.cardInfoText}>
					{`${recruiter}: ${feedbackInfo.recruiterName}`}
				</Typography>
			</Box>
		);
	}
	return null;
};
const CardInfo = ({ feedbackInfo, view, classes }) => {
	const { t, i18n } = useTranslation(['candidate-feedback', 'common']);

	const date = new Intl.DateTimeFormat(i18n.language, {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	}).format(new Date(feedbackInfo.interviewDate || feedbackInfo.requestedOn));

	const { interviewDate, requestedDate, recruiter, jobTitle, jobLocation, feedback } = useMemo(
		() => ({
			candidate: t('candidate'),
			interviewer: t('interviewer'),
			interviewDate: t('interview_date', { date }),
			requestedDate: t('requested_date', { date }),
			recruiter: t('recruiter'),
			jobTitle: t('job_title'),
			jobLocation: t('job_location'),
			feedback: t('feedback'),
		}),
		[t, date],
	);

	return (
		<>
			{view === 'dashboardView' ? (
				<Box sx={classes.cardInfo}>
					<BriefcaseChecked sx={classes.icon} />
					<span className="screenreader">{jobTitle}</span>
					<Typography sx={classes.cardInfoText}>{feedbackInfo.jobTitle}</Typography>
				</Box>
			) : null}
			{view === 'dashboardView' && feedbackInfo.jobLocation ? (
				<Box sx={classes.cardInfo}>
					<Location sx={classes.icon} />
					<span className="screenreader">{jobLocation}</span>
					<Typography sx={classes.cardInfoText}>{feedbackInfo.jobLocation}</Typography>
				</Box>
			) : null}
			<Box sx={classes.cardInfo}>
				<Calendar sx={classes.icon} />
				<Typography sx={classes.cardInfoText}>
					{feedbackInfo.interviewDate ? interviewDate : requestedDate}
				</Typography>
			</Box>
			{renderRecruiterInfo(feedbackInfo, view, classes, recruiter)}

			{view === 'feedbackTabView' && feedbackInfo.feedbackRequestForm.displayNamesMap !== null && (
				<Box sx={classes.cardInfo}>
					<IForms sx={classes.icon} />
					<Typography
						data-testid="feedback-form-name"
						sx={classes.cardInfoText}
					>{`${feedback}: ${Object.values(feedbackInfo.feedbackRequestForm.displayNamesMap)[0]}`}</Typography>
				</Box>
			)}
		</>
	);
};

export default CardInfo;
